import PropTypes from 'prop-types';

export const position = PropTypes.shape({
  right: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
  bottom: PropTypes.number.isRequired,
});

export const size = PropTypes.shape({
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  position,
});

export default {
  size,
  position
}


// WEBPACK FOOTER //
// ./src/prop-types/sizeMe.js